import { getWheelDirection, isPreventTime } from './mouseWheel';

class SceneBox {
    constructor (_option) {
        if (!_option) {
            throw new TypeError('sceneBox module Need option object');
        }
        
        this.context = $(_option.selector);
        
        this.config = $.extend({
            selector: '',
            changeSpeed: 1,
            render: 0,
            renderDelay: 0,
            noRender: false,
            onStartCallback: null,
            onCompleteCallback: null,
            onAnimation: null,
            linkButton: '[data-scene-link] a',
        }, _option);
        
        this.detect = {
            state: {
                isChange: false,
                introPlay: false,
                nowLayout: 0,
                lastWheelTime: new Date().getTime(),
                direction: '',
                to: 0,
            },
            dimension: {
                containerWidth: 0,
                containerHeight: 0,
            },
            sceneList: null,
            sceneSize: 0,
            sceneLayoutObj: [],
            sceneLayoutName: [],
            sceneDetailAnimation: {},
            touch: {
                distanceX: 0,
                distanceY: 0,
                startX: 0,
                startPointX: 0,
                startPointY: 0,
                end: true,
            },
        };
        
        this.detect.sceneList = this.context.find('[data-scene]');
        this.detect.sceneSize = this.detect.sceneList.length;
        
        this._setEvent();
        this._detectContextSize();
        
        for (let i = 0, max = this.detect.sceneSize - 1; i <= max; i++) {
            this.detect.sceneLayoutObj.push($(this.detect.sceneList[i]));
            this.detect.sceneLayoutName.push($(this.detect.sceneList[i]).attr('data-scene'));
        }
        
        const to = $.inArray($(location.hash).attr('data-scene'), this.detect.sceneLayoutName) > -1 ? $.inArray($(location.hash).attr('data-scene'), this.detect.sceneLayoutName) : this.config.render;
        
        if (!this.config.noRender) {
            setTimeout(() => {
                this.render(to, true);
            }, this.config.renderDelay * 1000);
        }
    }
    
    _setEvent () {
        $(window).on('hashchange.ui.scenebox', () => {
            if ($.inArray($(location.hash).attr('data-scene'), this.detect.sceneLayoutName) < 0) return;
            this.render($.inArray($(location.hash).attr('data-scene'), this.detect.sceneLayoutName));
        });
        
        $(window).on('resize.ui.scenebox', (e) => {
            this._resize(e);
        });
        
        $(document).on('click.ui.scenebox', this.config.linkButton, (e) => {
            this._link(e);
        });
        
        if ('ontouchstart' in window) {
            this.context.on('touchstart.ui.scenebox', (e) => {
                e.stopPropagation();
                this._touchStart(e);
            });
            this.context.on('touchmove.ui.scenebox', (e) => {
                e.stopPropagation();
                this._touchMove(e);
            });
            this.context.on('touchend.ui.scenebox touchcancel.ui.scenebox', (e) => {
                e.stopPropagation();
                this._touchEnd(e);
            });
        } else {
            this.context.on('mousewheel.ui.scenebox DOMMouseScroll.ui.scenebox', (e) => {
                e.stopPropagation();
                this._wheel(e);
            });
        }
    }
    
    _detectContextSize () {
        this.detect.dimension.containerWidth = this.context[0].offsetWidth;
        this.detect.dimension.containerHeight = this.context[0].offsetHeight;
    }
    
    _resize () {
        this._detectContextSize();
        TweenMax.set($('.now', this.context), {clip: `rect(0, ${this.detect.dimension.containerWidth}, ${this.detect.dimension.containerHeight}, 0)`});
        TweenMax.set($('[data-scene-change="show"]', this.context), {clip: `rect(0, ${this.detect.dimension.containerWidth}, ${this.detect.dimension.containerHeight}, 0)`});
    }
    
    _onStart (to, after, before, action) {
        this.detect.state.nowLayout = to;
        
        $('.now', this.context).removeClass('now');
        $('.before', this.context).removeClass('before');
        
        if (action === 'play') {
            after.addClass('now');
            before.addClass('before');
        }
        
        if (action === 'reverse') {
            after.addClass('before');
            before.addClass('now');
        }
        
        if (this.config.onStartCallback) {
            this.config.onStartCallback();
        }
        
        this.config.onAnimation();
    }
    
    _onComplete (after, before, action) {
        this.detect.state.isChange = false;
        
        if (action === 'reverse') {
            $('.now', this.context).removeClass('now');
            $('.before', this.context).removeClass('before');
            after.addClass('now');
            before.addClass('before');
        }
        
        if (this.config.onCompleteCallback) {
            this.config.onCompleteCallback();
        }
        
        if (!this.detect.state.introPlay) {
            this.detect.state.introPlay = true;
        }
        
    }
    
    _touchStart (e) {
        const point = e.originalEvent.touches ? e.originalEvent.touches[0] : e.originalEvent;
        
        this.detect.touch.distanceX = 0;
        this.detect.touch.distanceY = 0;
        this.detect.touch.startPointX = point.pageX;
        this.detect.touch.startPointY = point.pageY;
    }
    
    _touchMove (e) {
        if (!this.detect.touch.end) return;
        this.detect.touch.end = false;
        
        if (isPreventTime(this.detect.state.lastWheelTime)) return;
        this.detect.state.lastWheelTime = new Date().getTime();
        
        this.context.css({'pointer-events': 'none'});
        
        const point = e.originalEvent.touches ? e.originalEvent.touches[0] : e.originalEvent;
        
        this.detect.touch.distanceX += point.pageX - this.detect.touch.startPointX;
        this.detect.touch.distanceY += point.pageY - this.detect.touch.startPointY;
        
        if (Math.abs(this.detect.touch.distanceY) < 5) return;
        
        const directionY = this.detect.touch.distanceY > 0 ? -1 : 1;
        
        if (this.detect.state.nowLayout + directionY < 0 || this.detect.state.nowLayout + directionY > this.detect.sceneSize - 1) return;
        
        this.render(this.detect.state.nowLayout + directionY);
    }
    
    _touchEnd () {
        this.context.css({'pointer-events': 'auto'});
        this.detect.touch.end = true;
    }
    
    _wheel (e) {
        if (isPreventTime(this.detect.state.lastWheelTime)) return;
        this.detect.state.lastWheelTime = new Date().getTime();
        
        const direction = getWheelDirection(e);
        
        if (this.detect.state.nowLayout + direction < 0 || this.detect.state.nowLayout + direction > this.detect.sceneSize - 1) return;
        
        this.render(this.detect.state.nowLayout + direction);
    }
    
    _link (e) {
        e.preventDefault();
        
        if (this.detect.state.isChange) return;
        
        const target = $(e.target).attr('data-scene-link') ? $(e.target).attr('data-scene-link') : e.target.hash,
            idx = $.inArray($(target).attr('data-scene'), this.detect.sceneLayoutName);
        
        if ((idx - this.detect.state.nowLayout) === 0) return;
        
        this.render(idx);
    }
    
    _play (to, noAnimation) {
        this.detect.state.direction = 'play';
        
        const after = this.detect.sceneLayoutObj[to],
            before = this.detect.sceneLayoutObj[this.detect.state.nowLayout],
            width = this.detect.dimension.containerWidth,
            height = this.detect.dimension.containerHeight,
            speed = this.config.changeSpeed;
        
        let toValue = (...value) => {
            return {
                [value[0]]: value[1],
                onStart: this._onStart,
                onComplete: this._onComplete,
                onStartParams: [to, after, before, 'play'],
                onCompleteParams: [after, before, 'play'],
                callbackScope: this,
                ease: Quint.easeInOut,
            };
        };
        
        switch (after.attr('data-scene-change')) {
            case 'top':
                TweenMax.fromTo(after, noAnimation ? 0.1 : speed,
                    {clip: `rect(0, ${width}, 0, 0)`}, toValue('clip', `rect(0, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'bottom':
                TweenMax.fromTo(after, noAnimation ? 0.1 : speed,
                    {clip: `rect(${height}, ${width}, ${height}, 0)`}, toValue('clip', `rect(0, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'left':
                TweenMax.fromTo(after, noAnimation ? 0.1 : speed,
                    {clip: `rect(0, 0,${height}, 0)`}, toValue('clip', `rect(0, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'right':
                TweenMax.fromTo(after, noAnimation ? 0.1 : speed,
                    {clip: `rect(0, ${width}, ${height}, ${width})`}, toValue('clip', `rect(0, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'square':
                TweenMax.fromTo(after, noAnimation ? 0.1 : speed,
                    {clip: `rect(${height / 2}, ${width / 2}, ${height / 2}, ${width / 2})`}, toValue('clip', `rect(0, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'openY':
                TweenMax.fromTo(after, noAnimation ? 0.1 : speed,
                    {clip: `rect(0, ${width / 2}, ${height}, ${width / 2})`}, toValue('clip', `rect(0, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'openX':
                TweenMax.fromTo(after, noAnimation ? 0.1 : speed,
                    {clip: `rect(${height / 2}, ${width}, ${height / 2}, 0)`}, toValue('clip', `rect(0, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'show':
                TweenMax.from(after, .1, toValue('opacity', 0));
                break;
            
            case 'fade':
                after.css({opacity: ''});
                TweenMax.from(after, noAnimation ? 0.1 : speed, toValue('opacity', 0));
                break;
        }
    }
    
    _reverse (to) {
        this.detect.state.direction = 'reverse';
        
        const after = this.detect.sceneLayoutObj[to],
            before = this.detect.sceneLayoutObj[this.detect.state.nowLayout],
            width = this.detect.dimension.containerWidth,
            height = this.detect.dimension.containerHeight,
            speed = this.config.changeSpeed;
        
        let toValue = (...value) => {
            return {
                [value[0]]: value[1],
                onStart: this._onStart,
                onComplete: this._onComplete,
                onStartParams: [to, after, before, 'reverse'],
                onCompleteParams: [after, before, 'reverse'],
                callbackScope: this,
                ease: Quint.easeInOut,
            };
        };
        
        switch (after.attr('data-scene-change')) {
            case 'top':
            case 'bottom':
            case 'left':
            case 'right':
            case 'square':
            case 'openY':
            case 'openX':
                TweenMax.set(after, {clip: `rect(0, ${width}, ${height}, 0)`});
                break;
            
            case 'show':
            case 'fade':
                TweenMax.set(after, {opacity: 1});
                break;
        }
        
        switch (before.attr('data-scene-change')) {
            case 'top':
                TweenMax.fromTo(before, speed,
                    {clip: `rect(0, ${width} , ${height}, 0)`}, toValue('clip', `rect(0, ${width}, 0, 0)`),
                );
                break;
            
            case 'bottom':
                TweenMax.fromTo(before, speed,
                    {clip: `rect(0, ${width} , ${height}, 0)`}, toValue('clip', `rect(${height}, ${width}, ${height}, 0)`),
                );
                break;
            
            case 'left':
                TweenMax.fromTo(before, speed,
                    {clip: `rect(0, ${width}, ${height}, 0)`}, toValue('clip', `rect(0, 0, ${height}, 0)`),
                );
                break;
            
            case 'right':
                TweenMax.fromTo(before, speed,
                    {clip: `rect(0, ${width}, ${height}, 0)`}, toValue('clip', `rect(0, ${width}, ${height}, ${width})`),
                );
                break;
            
            case 'square':
                TweenMax.fromTo(before, speed,
                    {clip: `rect(0, ${width}, ${height}, 0)`}, toValue('clip', `rect(${height / 2}, ${width / 2}, ${height / 2}, ${width / 2})`),
                );
                break;
            
            case 'openY':
                TweenMax.fromTo(before, speed,
                    {clip: `rect(0, ${width}, ${height}, 0)`}, toValue('clip', `rect(0, ${width / 2},  ${height}, ${width / 2})`),
                );
                break;
            
            case 'openX':
                TweenMax.fromTo(before, speed,
                    {clip: `rect(0, ${width}, ${height}, 0)`}, toValue('clip', `rect(${height / 2}, ${width},  ${height / 2}, 0)`),
                );
                break;
            
            case 'fade':
                TweenMax.to(before, speed, toValue('opacity', 0));
                break;
            
            case 'show':
                TweenMax.from(before, .1, toValue('opacity', 1));
                break;
        }
    }
    
    setDetailAnimation (sceneName, queue) {
        this.detect.sceneDetailAnimation[sceneName] = queue;
    }
    
    render (to, noAnimation) {
        if (this.detect.state.isChange) return;
        this.detect.state.isChange = true;
        
        if (typeof to === 'string') {
            to = $.inArray($(to).attr('data-scene'), this.detect.sceneLayoutName);
        }
        
        let queue = this.detect.sceneDetailAnimation[this.detect.sceneLayoutName[to]];
        
        if (this.detect.state.introPlay && to === this.detect.state.nowLayout) return;
        
        this.state.to = to;
        
        if (to >= this.detect.state.nowLayout) {
            this._play(to, noAnimation);
            
            if (to === 0 && !this.detect.state.introPlay) {
                if (queue) {
                    queue.play ? queue.play('intro') : queue();
                }
                return;
            }
            
            if (queue) {
                queue.play ? queue.play(0) : queue();
            }
            
        } else {
            this._reverse(to);
            if (queue) {
                queue.play ? queue.play('start') : queue();
            }
        }
        
    }
    
    get state () {
        return this.detect.state;
    }
}

export default SceneBox;